import { KategoriPaketSoalRepositoryInterface } from '../../../data/contracts/KategoriPaketSoal';
import { KategoriPaketSoalDataMapper } from '../../../data/mappers/KategoriPaketSoal';
import { Endpoints } from '../../misc/Endpoints';
import ApiService from '../../services/ApiService';
import { KategoriPaketSoal } from '../../../entities/KategoriPaketSoal';

export class KategoriPaketSoalApiRepository
  implements KategoriPaketSoalRepositoryInterface
{
  private apiService: ApiService;
  private mapper: KategoriPaketSoalDataMapper;
  private endpoints: Endpoints;

  constructor(
    apiService: ApiService,
    mapper: KategoriPaketSoalDataMapper,
    endpoints: Endpoints
  ) {
    this.apiService = apiService;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getAllKategoriPaketSoal(
    page: number,
    rows: number,
    keyword: string
  ): Promise<KategoriPaketSoal[]> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'get',
      this.endpoints.kategoriPaketSoal(),
      {
        page: page,
        rows: rows,
        keyword: keyword,
      },
      null,
      headers
    );
    return this.mapper.convertListKategoriPaketSoalDataFromApi(dataResponse);
  }

  public async storeKategoriPaketSoal(
    kategori_paket_soal: string
  ): Promise<any> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'post',
      this.endpoints.kategoriPaketSoal(),
      {
        kategori_paket_soal: kategori_paket_soal,
      },
      null,
      headers
    );
    return dataResponse;
  }

  public async updateKategoriPaketSoal(
    id: number,
    kategori_paket_soal: string
  ): Promise<any> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'post',
      this.endpoints.kategoriPaketSoal() + '/' + id,
      {
        kategori_paket_soal: kategori_paket_soal,
      },
      null,
      headers
    );
    return dataResponse;
  }

  public async deleteKategoriPaketSoal(id: number): Promise<any> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'delete',
      this.endpoints.kategoriPaketSoal() + '/' + id,
      {},
      null,
      headers
    );
    return dataResponse;
  }
}
